// [ai-refactored-code]
import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GaragePassage } from '@/models/garage-passage.model';
import { Registry } from '@/registry.service';
import { LoggerService } from '@services/logger.service';

@Component({
  selector: 'app-garage-passage-detail-dialog',
  templateUrl: './garage-passage-detail-dialog.component.html',
  styleUrls: ['./garage-passage-detail-dialog.component.scss'],
})
export class GaragePassageDetailDialogComponent implements OnInit {
  modalClose = new EventEmitter<GaragePassage>();

  constructor(
    public dialogRef: MatDialogRef<GaragePassageDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GaragePassage,
  ) {}

  ngOnInit(): void {
    // Log dei dati del dettaglio CEM quando viene aperto
    console.log('=== DETTAGLIO RECORD CEM APERTO ===');
    console.log('Dati completi del record CEM:', this.data);
    console.log('===================================');
    LoggerService.log(this.data, 'Dettaglio record CEM - Dati aperti');

    // Register this dialog in Registry for potential access from other components
    Registry.getInstance().set('GaragePassageDetailDialog', this.dialogRef);

    // Subscribe to modalClose events from the form
    this.modalClose.subscribe((updatedPassage: GaragePassage) => {
      this.dialogRef.close(updatedPassage);
    });
  }
}
